export enum OwnershipReasonEnum {
  divorce = 'divorce',
  inclusion_due_to_marriage = 'inclusion_due_to_marriage',
  moving_out_due_to_marriage = 'moving_out_due_to_marriage',
  financial_difficulties = 'financial_difficulties',
  demise_of_current_owner = 'demise_of_current_owner',
  renunciation = 'renunciation',
  moving_out_others = 'moving_out_others',
  medical = 'medical',
}
